import { useEffect, useRef, useState } from 'react'

import {
	useNotificationStore,
	wwtNotificationLog
} from '@wwt/core/notifications'
import { NotificationStatus } from '@wwt/entities/api/search-response'

import { useToast } from '@/shared/lib/hooks/useToast'
import { Notification, NotificationProps } from '@/widgets/NotificationPopup'
import NotificationAggregation from '@/widgets/NotificationPopup/ui/NotificationAggregation'

export const useNotificationPopups = () => {
	wwtNotificationLog('Notifications in todo')
	const { toast } = useToast()
	const { notifications, updateNotificationsStatus } = useNotificationStore()
	const [countCells, setCountCells] = useState(3)
	const refCountCells = useRef(countCells)

	const showNotification = ({ onClose, ...props }: NotificationProps) => {
		refCountCells.current = Math.max(refCountCells.current - 1, 0)
		setCountCells(refCountCells.current)
		const notificationToast = toast({
			layer: 'modals',
			className: 'block pr-4',
			custom: (
				<Notification
					onClose={() => {
						onClose()
						notificationToast.dismiss()
					}}
					{...props}
				/>
			)
		})
		setTimeout(() => {
			refCountCells.current = Math.min(refCountCells.current + 1, 3)
			setCountCells(refCountCells.current)
		}, 5000)

		updateNotificationsStatus({
			[props.notification.notificationId]: NotificationStatus.SHOWN_POPUP
		})
	}

	const showNotificationAggregation = (count: number) => {
		refCountCells.current = Math.max(refCountCells.current - 1, 0)
		setCountCells(refCountCells.current)
		const aggregationToast = toast({
			layer: 'modals',
			className: 'block pr-4',
			custom: (
				<NotificationAggregation
					count={count}
					onClose={() => {
						aggregationToast.dismiss()
					}}
				/>
			)
		})
		setTimeout(() => {
			refCountCells.current = Math.min(refCountCells.current + 1, 3)
			setCountCells(refCountCells.current)
		}, 5000)
	}

	useEffect(() => {
		if (refCountCells.current <= 0 || refCountCells.current > 3) return

		if (notifications.NEW.length > 3) {
			showNotificationAggregation(notifications.NEW.length)

			notifications.NEW.forEach(notification => {
				updateNotificationsStatus({
					[notification.notificationId]: NotificationStatus.SHOWN_POPUP
				})
			})
		} else {
			const notification = notifications.NEW.at(0)
			if (notification) {
				showNotification({
					// eslint-disable-next-line @typescript-eslint/no-empty-function
					onClose: () => {},
					notification: notification
				})
			}
		}
	}, [notifications, countCells])
}
